import jwtAuthAxios from "./auth/jwtAuth";

// Un telefono por cuenta de conductor. Ver hermes-backend app/controllers/api/v1/mobile_devices_controller.rb.
const mobileDeviceServices = {};

mobileDeviceServices.list = async () => (await jwtAuthAxios.get("/mobile_devices")).data;
mobileDeviceServices.approve = async (id) => (await jwtAuthAxios.post(`/mobile_devices/${id}/approve`)).data;
mobileDeviceServices.reject = async (id) => (await jwtAuthAxios.post(`/mobile_devices/${id}/reject`)).data;
mobileDeviceServices.release = async (userId) => (await jwtAuthAxios.post("/mobile_devices/release", { user_id: userId })).data;

export default mobileDeviceServices;
